// extracted by mini-css-extract-plugin
module.exports = {"InfoValue":"Dashboard_InfoValue__2p98u","InfoText":"Dashboard_InfoText__1LDXf","contactTile":"Dashboard_contactTile__1X15C"};